export const EMAIL_API_ENDPOINT = "/api/auth/email";
